// extracted by mini-css-extract-plugin
export var checkboxes = "form-module--checkboxes--f592c";
export var commonForm = "form-module--common-form--6ac4c";
export var hideElement = "form-module--hide-element--237d2";
export var inside = "form-module--inside--ab0c8";
export var oneLine = "form-module--one-line--edaa7";